import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { AuthGuardService } from '../../authentication/auth-guard.service';
import { EmployeesDashboardComponent } from './employees-dashboard.component';
import { MatButtonModule, MatDatepickerModule, MatDividerModule, MatFormFieldModule, MatIconModule, MatInputModule, MatPaginatorModule, MatSidenavModule, MatTableModule, MatTabsModule } from '@angular/material';
import { FlexLayoutModule } from '@angular/flex-layout';
import { TableModule } from 'primeng/table';
import { MultiSelectModule } from 'primeng/primeng';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { YearlyReportComponent } from './yearly-report/yearly-report.component';
import { EmployeeDashboardV1Component } from './employee-dashboard-v1/employee-dashboard-v1.component';
import { HighchartsChartModule } from 'highcharts-angular';
import { MaterialModule } from 'app/shared/material.module';
import { FuseWidgetModule } from '@fuse/components';

const routes = [
  { path: '', redirectTo: 'employees-dashboard', pathMatch: 'full', canActivate: [AuthGuardService] },
  { path: 'employees-dashboard', component: EmployeeDashboardV1Component, canActivate: [AuthGuardService] },
  { path: 'yearly-dashboard', component: YearlyReportComponent, canActivate: [AuthGuardService] }
];

@NgModule({
  declarations: [
    EmployeesDashboardComponent, 
    EmployeeDashboardV1Component,
    YearlyReportComponent,
  ],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    MatIconModule,
    FlexLayoutModule,
    TableModule,
    MultiSelectModule,
    MatDatepickerModule,
    MatFormFieldModule,
    FormsModule,
    ReactiveFormsModule,
    MatInputModule,
    MatTabsModule,
    MatPaginatorModule,
    MatSidenavModule,
    MatTableModule,
    MatButtonModule,
    NgxChartsModule,
    MatDividerModule,
    HighchartsChartModule,
    MaterialModule,
    FuseWidgetModule
  ]
})
export class EmployeesDashboardModule { }
